import { BodyText } from "@/components/ui/Text";

interface GenericSystemMessageProps {
  text: string;
}

export const GenericSystemMessage = ({ text }: GenericSystemMessageProps) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        {text}
      </BodyText>
    </div>
  );
};
